import { createActionHandler, createReducer } from '@pressreader/appstore';

import { AnyCommentAttachment } from '../../types/comment.attachment';
import { attachmentDeleted, attachmentUploadDone, attachmentUploadFailed, attachmentUploadStarted } from '../actions/attachments';
import { commentEditCancelled, commentEditStarted } from '../actions/comments';

export interface State {
    // A dictionary with new attachments by draftId.
    attachmentsByDraftId: Record<string, AnyCommentAttachment[]>;
}

const initialState: State = {
    attachmentsByDraftId: {},
};

export const reducer = createReducer(
    initialState,
    createActionHandler(attachmentUploadStarted, (state, { payload: { draftId, attachment } }) => ({
        ...state,
        attachmentsByDraftId: {
            ...state.attachmentsByDraftId,
            [draftId]: [...(state.attachmentsByDraftId?.[draftId] ?? {}), attachment],
        },
    })),
    createActionHandler(attachmentUploadDone, (state, { payload: { draftId, attachment } }) => {
        const attachments = state.attachmentsByDraftId[draftId];
        const idx = attachments.findIndex(a => a.uniqueId === attachment.uniqueId);
        if (idx < 0) {
            return state;
        }

        return {
            ...state,
            attachmentsByDraftId: {
                ...state.attachmentsByDraftId,
                [draftId]: [...attachments.slice(0, idx), attachment, ...attachments.slice(idx + 1)],
            },
        };
    }),
    createActionHandler(attachmentUploadFailed, (state, { payload: { draftId, attachment } }) => ({
        ...state,
        attachmentsByDraftId: {
            ...state.attachmentsByDraftId,
            [draftId]: state.attachmentsByDraftId[draftId].filter(a => a.uniqueId !== attachment.uniqueId),
        },
    })),
    createActionHandler(commentEditStarted, (state, { payload: { draftId, comment } }) => ({
        ...state,
        attachmentsByDraftId: { ...state.attachmentsByDraftId, [draftId]: comment?.attachments ?? [] },
    })),
    createActionHandler(commentEditCancelled, (state, { payload: { draftId } }) => {
        const attachmentsByDraftId = { ...state.attachmentsByDraftId };
        delete attachmentsByDraftId[draftId];

        return {
            ...state,
            attachmentsByDraftId,
        };
    }),
    createActionHandler(attachmentDeleted, (state, { payload: { id, draftId } }) => ({
        ...state,
        attachmentsByDraftId: {
            ...state.attachmentsByDraftId,
            [draftId]: state.attachmentsByDraftId[draftId]?.filter(a => a.uniqueId !== id),
        },
    })),
);
